import versions from './versions'

class UserDecorator {
  wrapped = {}

  setDecorator (version) {
    this.wrapped = versions[version]
  }

  hasPermission (user, ...validPermissions) {
    // TODO: UserDecorator não está funcionando. O método não está disponível em uma nova instância (aba/janela)
    return this.wrapped.hasPermission?.(user, ...validPermissions)
  }
}

export default new UserDecorator()
